import { number, object, SchemaOf, string } from 'yup'
import { IValidationQuestions } from '../../interfaces'
import IStep from '../../interfaces/Step'

export const validationQuestions = (
	props: IStep[],
): SchemaOf<IValidationQuestions> => {
	const schema: { [x: string]: any } = {}
	Object.entries(props).forEach(prop => {
		schema[prop[1].name] = object().shape({
			_id: string().required('Id da etapa é obrigatóprio.').nullable(),
			questions: questionSchema(prop[1].questions),
		})
	})
	return object().shape({ ...schema })
}

export const questionSchema = (
	props: Array<{ _id: string; question: string }>,
): SchemaOf<{ [_id: string]: number }> => {
	const schema: { [x: string]: any } = {}
	props.forEach(prop => {
		schema[prop._id] = number().required('Resposta é obrigatória.')
	})
	return object().shape({ ...schema })
}
// export default validationQuestions
